import Button from '../Button';
import { ButtonHTMLAttributes } from 'react';
import { VideoShape } from '@/types';
import { useThrottle } from '@/hooks/use-trottle';
import DownloadVideoSVG from '@/svg/download-video.svg';

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
    activeVideo: VideoShape | null;
};

const DownloadVideoButton = ({ activeVideo }: Props) => {
    const handleDownloadVideo = useThrottle(() => {
        if (!activeVideo) return;

        const videoSource = activeVideo[0]?.src;
        if (!videoSource) return;

        const link = document.createElement('a');
        link.href = videoSource;
        link.download = `video-${Math.floor(Math.random() * 1000)}`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }, 3000);

    return (
        <Button onClick={handleDownloadVideo} disabled={!activeVideo} aria-label="Скачать видео">
            <DownloadVideoSVG />
        </Button>
    );
};

export default DownloadVideoButton;
